import type { NodeMock, StatePreset } from "../mock-types";

export const hostInstructionsMock: NodeMock = {
  label: "Host Instructions",
  description: "Host follows setup instructions",
  state: () => ({
    instructions: [
      "Open the game and go to Custom Match",
      "Create a new lobby with the following settings: Competitive, Best of 1",
      "Set the map to the one shown above",
      "Invite all players to the lobby",
    ],
    hostConfirmed: false,
    hostUserId: "player_0",
  }),
  config: {
    timeoutSeconds: 120,
    instructions: "Create a custom lobby and invite all players.",
    requireHostConfirmation: true,
    labels: {
      title: "Mission Briefing",
      subtitle: "Complete these steps to set up the match",
    },
  },
};

export const hostInstructionsPresets: StatePreset[] = [
  {
    label: "Host View",
    build: ({ players, defaultState }) => ({
      state: {
        ...defaultState,
        hostConfirmed: false,
        hostUserId: players[0]?.userId ?? "player_0",
      },
      viewAs: players[0]?.userId,
    }),
  },
  {
    label: "Host Done",
    build: ({ players, defaultState }) => ({
      state: {
        ...defaultState,
        hostConfirmed: true,
        hostUserId: players[0]?.userId ?? "player_0",
      },
      viewAs: players[0]?.userId,
    }),
  },
  {
    label: "Non-Host",
    build: ({ players, defaultState }) => ({
      state: {
        ...defaultState,
        hostConfirmed: false,
        hostUserId: players[0]?.userId ?? "player_0",
      },
      viewAs: players[1]?.userId ?? players[0]?.userId,
    }),
  },
];
